import * as React from "react";
import type { SVGProps } from "react";
const AlignTopIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M3 5.75A.75.75 0 0 1 3.75 5h16a.75.75 0 0 1 0 1.5h-4.031a1 1 0 0 1 .031.25v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-12a1 1 0 0 1 .031-.25H10.72a1 1 0 0 1 .031.25v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-6q0-.13.032-.25H3.75A.75.75 0 0 1 3 5.75" clipRule="evenodd" /></svg>;
export default AlignTopIcon;